import React from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import Header from '../../commons/Header/Header';
import Translate from '../../../utils/Translate';
import './ActiveSessionPage.css';
import ActiveSessionsContainer from './ActiveSession/ActiveSessionsContainer';
import DomUtils from '../../../utils/DomUtils';
import Alert from '../../commons/Alert/Alert';
import * as Pages from "../../../utils/Pages";

@withRouter
class ActiveSessionsPage extends React.Component {
  constructor(props) {
    super(props);
    this.node = React.createRef();
  }

  componentDidMount() {
    DomUtils.scroll(this.node, { block: 'start' });
  }

  render() {
    return (
      <div ref={(node) => { this.node = node; }} >
        <div className="eva-3-dashboard-aftersale ActiveSessionPage -eva-3-mb-xlg -eva-3-bc-gray-4">
          <Header
            name={Translate.message('Sesiones activas')}
            page={Pages.ACTIVE_SESSIONS}
          />
          <div className="eva-3-container -eva-3-bc-gray-4 -p-0 -p-md-2 -pb-md-4 -pl-md-5 -pr-md-5 -pt-4">
            <div className="dashboard-aftersale-results-container eva-3-row -no-gutter">
              {
                this.props.isMerging &&
                <div className="col -sm-12 -lg-8 -eva-3-mb-lg">
                  <Alert type="warning" title={Translate.message('Estamos uniendo tus cuentas')}>
                    {Translate.message('Mientras se realiza el proceso, no podrás modificar los datos de tu perfil. Por favor, regresá más tarde.')}
                  </Alert>
                </div>
              }
              <div className="col -sm-12 -lg-8 subnav-profile">
                <ActiveSessionsContainer
                  activeSessionPage={this.props.activeSessionPage}
                  hasError={this.props.clustersErrors.activeSessions}
                  isMerging={this.props.isMerging}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

ActiveSessionsPage.propTypes = {
  activeSessionPage: PropTypes.shape().isRequired,
  clustersErrors: PropTypes.shape().isRequired,
  isMerging: PropTypes.bool.isRequired,
};

export default ActiveSessionsPage;
